export default __webpack_public_path__ + "static/media/marina.064c0689.jpg";